export default class Navigation {
    static goTo = (url, history) => history.push(url);
}



// WEBPACK FOOTER //
// ./js/mywort/commons/utils/Navigation.js